import { useRouter } from "@core/Api/useRouter";
import { useItemLinks } from "@core-ui/stores/ItemLinksStore/ItemLinksStore.provider";
import { DeleteItemButton } from "@ext/item/actions/DeleteItemButton";
import ItemMenu from "@ext/item/EditMenu";
import { useCurrentItemActions } from "@ext/item/useCurrentItemActions";
import t from "@ext/localization/locale/translate";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@ui-kit/Dropdown";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";
import { useState } from "react";
import { CollapsedNavigationTrigger } from "./CollapsedNavigationTrigger";

export const CollapsedArticleActions = () => {
	const itemLinks = useItemLinks();
	const isMarkdownMode = useRouter().query?.mode === "markdown";
	const { itemLink, setItemLink, isDeleteOnly, isMenuVisible } = useCurrentItemActions(itemLinks, !isMarkdownMode);
	const [isOpen, setIsOpen] = useState(false);

	if (!isMenuVisible) return null;

	if (isDeleteOnly) {
		return (
			<DeleteItemButton itemLink={itemLink}>
				<CollapsedNavigationTrigger icon="trash" label={t("delete")} />
			</DeleteItemButton>
		);
	}

	const label = t("article.actions.title");

	return (
		<DropdownMenu modal={false} onOpenChange={setIsOpen} open={isOpen}>
			<Tooltip>
				<TooltipTrigger asChild>
					<DropdownMenuTrigger asChild>
						<CollapsedNavigationTrigger active={isOpen} icon="ellipsis" label={label} />
					</DropdownMenuTrigger>
				</TooltipTrigger>
				<TooltipContent focus="high">{label}</TooltipContent>
			</Tooltip>
			<DropdownMenuContent align="end">
				<ItemMenu itemLink={itemLink} setItemLink={setItemLink} />
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
